/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

window.Parsley.addValidator('addsPrefix', {
  requirementType: 'string',
  validateString(value, requirement, instance) {
    const prefix = requirement + ' ';
    const prefixedLength = value.startsWith(prefix) ? value.length : value.length + prefix.length;

    const maxlength = instance.$element.attr('maxlength');
    if (prefixedLength > maxlength) {
      return $.Deferred().reject(
        `This value is too long. It should have ${maxlength} characters or fewer, including a preceding "${prefix}".`
      );
    }

    return true;
  }
});
